var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBackIcon = function SvgBackIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.53 5.47001C10.6705 5.61064 10.7494 5.80126 10.7494 6.00001C10.7494 6.19876 10.6705 6.38939 10.53 6.53001L5.81001 11.25H20C20.1989 11.25 20.3897 11.329 20.5303 11.4697C20.671 11.6103 20.75 11.8011 20.75 12C20.75 12.1989 20.671 12.3897 20.5303 12.5303C20.3897 12.671 20.1989 12.75 20 12.75H5.81001L10.53 17.47C10.6037 17.5387 10.6628 17.6215 10.7038 17.7135C10.7448 17.8055 10.7668 17.9048 10.7686 18.0055C10.7704 18.1062 10.7519 18.2062 10.7141 18.2996C10.6764 18.393 10.6203 18.4778 10.549 18.549C10.4778 18.6203 10.393 18.6764 10.2996 18.7141C10.2062 18.7519 10.1062 18.7704 10.0055 18.7686C9.90479 18.7668 9.80547 18.7448 9.71347 18.7038C9.62147 18.6628 9.53867 18.6037 9.47001 18.53L3.47001 12.53C3.32956 12.3894 3.25067 12.1988 3.25067 12C3.25067 11.8013 3.32956 11.6106 3.47001 11.47L9.47001 5.47001C9.61064 5.32956 9.80126 5.25067 10 5.25067C10.1988 5.25067 10.3894 5.32956 10.53 5.47001Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBackIcon);
export default ForwardRef;